module.exports = __webpack_public_path__ + "img/pos1-txt.8cf9e1ba.png";